import { isArray } from 'lodash';
import { canRelatedOrgEditThisProfile, isAdmin } from './account';
import { isBrandsFocusedOrganization, isInfluencersFocusedOrganization } from './organization';

import type {
  Account,
  BrandProfile,
  Organization,
  Role
} from 'types';

function getProfilesIds(profiles) {
  return isArray(profiles) ? profiles.map(p => p.id) : [];
}

export function canUserEditInfluencerProfile(
  profile: {
    id: number,
    isLightweight?: boolean
  },
  currentOrganization: Organization,
  currentAccount: Account,
  roles: Array<Role>
) {
  if (profile.isLightweight) {
    return isAdmin(currentAccount, roles);
  }

  if (!currentOrganization) {
    return isAdmin(currentAccount, roles);
  }

  const influencerProfilesIds = getProfilesIds(currentOrganization.influencerProfiles);

  return isAdmin(currentAccount, roles)
    || canRelatedOrgEditThisProfile(currentAccount, profile.id)
    || (isInfluencersFocusedOrganization(currentOrganization) && influencerProfilesIds.includes(profile.id));
}

export function canUserEditBrandProfile(
  profile: BrandProfile,
  currentOrganization: Organization,
  currentAccount: Account,
  roles: Array<Role>
) {
  if (!currentOrganization) {
    return isAdmin(currentAccount, roles);
  }

  let brandProfilesIds = getProfilesIds(currentOrganization.brandProfiles);

  if (currentOrganization.agencyOrganizationId) {
    const agencyProfile = currentAccount.organizations.find(organization => organization.id === currentOrganization.agencyOrganizationId);

    if (agencyProfile) {
      brandProfilesIds = [...brandProfilesIds, ...getProfilesIds(agencyProfile.brandProfiles)];
    }
  }

  return isAdmin(currentAccount, roles) ||
    (isBrandsFocusedOrganization(currentOrganization) && brandProfilesIds.includes(profile.id));
}
